import { useToast } from '../contexts/ToastContext';

export function useWorkflowNotifications() {
  const { showToast } = useToast();
  
  return {
    workflowSaved: (name: string) => {
      showToast(`Workflow "${name}" saved successfully`, 'success');
    },
    workflowSaveError: (error: string) => {
      showToast(`Failed to save workflow: ${error}`, 'error');
    },
    workflowValidationError: (message: string) => {
      showToast(message, 'warning');
    },
    workflowExecutionStarted: (name: string) => {
      showToast(`Workflow "${name}" execution started`, 'info');
    },
    workflowExecutionError: (error: string) => {
      showToast(`Failed to start execution: ${error}`, 'error');
    },
    workflowPhaseCompleted: (phaseName: string) => {
      showToast(`Phase "${phaseName}" completed`, 'success');
    }
  };
}

export function usePersonaNotifications() {
  const { showToast } = useToast();
  
  return {
    personaCreated: (name: string) => {
      showToast(`Persona "${name}" created successfully`, 'success');
    },
    personaUpdated: (name: string) => {
      showToast(`Persona "${name}" updated successfully`, 'success');
    },
    personaError: (error: string) => {
      showToast(`Persona operation failed: ${error}`, 'error');
    }
  };
}

export function useArtifactNotifications() {
  const { showToast } = useToast();
  
  return {
    artifactCreated: (name: string) => {
      showToast(`Artifact "${name}" created successfully`, 'success');
    },
    artifactUpdated: (name: string) => {
      showToast(`Artifact "${name}" updated successfully`, 'success');
    },
    artifactError: (error: string) => {
      showToast(`Artifact operation failed: ${error}`, 'error');
    }
  };
}

export function useToolNotifications() {
  const { showToast } = useToast();
  
  return {
    toolUsed: (name: string) => {
      showToast(`Tool "${name}" used successfully`, 'success');
    },
    toolError: (error: string) => {
      showToast(`Tool operation failed: ${error}`, 'error');
    }
  };
}
